namespace MACRAIL.Validation {

export class ValueValidator implements IValidator {

    private opts: any;

    constructor (opts: any) {
        this.opts = opts;

        this.opts.status = this.opts.status || 'warning';
    }

    public validate(value: any) {

        let messages: IValidatorMessage[] = [];

        if (value === undefined) {
            return messages;
        }

        if (this.opts.states[value]) {
            messages.push({
                'slug': 'value',
                'status': this.opts.status,
                'message': this.opts.states[value],
            });
        }

        return messages;
    }
}

}
